import axios from 'axios';

const getGeneralCountriesApi = async (langIsoCode) => {
  try {
    const url = '/subscription/country/get';
    const res = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        lang: langIsoCode
      }
    });

    return res;
  } catch (error) {
    throw error;
  }
};

export default getGeneralCountriesApi;
